module.exports = __webpack_public_path__ + "img/withdraw_auth.a1f8af4f.png";